var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCopy16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_copy_16",
    transform: "translate(-493.25 -330.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 16,
    height: 16,
    transform: "translate(493.25 330.75)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329",
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4411",
    "data-name": "Path 4411",
    d: "M506.656,346.75h-6.312a2.1,2.1,0,0,1-2.094-2.094v-6.312a2.1,2.1,0,0,1,2.094-2.094h6.312a2.1,2.1,0,0,1,2.094,2.094v6.312A2.1,2.1,0,0,1,506.656,346.75Zm-6.312-9a.6.6,0,0,0-.594.594v6.312a.6.6,0,0,0,.594.594h6.312a.6.6,0,0,0,.594-.594v-6.312a.6.6,0,0,0-.594-.594Z",
    fill: "#a0a3c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4412",
    "data-name": "Path 4412",
    d: "M496.344,342.75a2.1,2.1,0,0,1-2.094-2.094v-6.312a2.1,2.1,0,0,1,2.094-2.094h6.312a2.1,2.1,0,0,1,2.094,2.094.75.75,0,0,1-1.5,0,.6.6,0,0,0-.594-.594h-6.312a.6.6,0,0,0-.594.594v6.312a.6.6,0,0,0,.594.594.75.75,0,0,1,0,1.5Z",
    fill: "#a0a3c4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy16);
export default __webpack_public_path__ + "static/media/ic_copy_16.5b289ecc56a99be2a7f68945e02e7196.svg";
export { ForwardRef as ReactComponent };